import React from 'react';

import { Typography } from 'redpoints-front-components/index';

import SocialMediaMessagesListItem from './SocialMediaMessagesListItem';
import { translate } from '../../helpers/languageHelper';

const getTextMessage = message => {
  let textMessage = '';

  if (typeof message === 'string') {
    textMessage = JSON.parse(message)?.text || '';
  }

  if (typeof message === 'object') {
    textMessage = message.text || '';
  }

  return textMessage;
};

const SocialMediaMessagesList = ({ messages, isNextMessage = false }) => (
  <section className="social-media-messages__list">
    <Typography type="primary">
      {isNextMessage
        ? translate('social_media_messages.nextMessages')
        : translate('social_media_messages.previousMessages')}
    </Typography>
    {messages.map((message, index) => (
      <SocialMediaMessagesListItem
        textMessage={getTextMessage(message)}
        key={`${index}_${message}`}
      />
    ))}
  </section>
);

export default SocialMediaMessagesList;
